import base from './base.repository';
export default {
    ...base,
    getManagementByClient(filters, page = 1){
        const params = {...filters, page: page};
        this.get(`internal-management${this.querify(params)}`);
        return this;
    },
    getTypes(){
        this.get('internal-management-types');
        return this;
    },
    saveInternalManagement(payload){
        this.post('internal-management', payload);
        return this;
    },
    deleteInternalManagement(id){
        this.delete('internal-management/'+ id);
        return this;
    },
}